import { Header, Input, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table.js";
import BackButton from "../../../components/BackButton/BackButton.js";
import ActionDropdown from "../../../components/ActionDropdown/ActionDropdown.js";
import Loading from "../../../components/Loading/Loading.js";
import { api } from "../../../api/api.js";
import { ReactComponent as EditIcon } from "../../../images/edit.svg";
import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import { ReactComponent as CopyIcon } from "../../../images/copy.svg";
import DeleteConfirmModal from "../../../components/ActionDropdown/DeleteConfirmModal.js";
import { recon_charges_url } from "../../../api/urls.js";
import axios from "axios";
import unknownError from "../../../utils/unknownError.js";
import { modules, perms } from "../../../api/codes.js";
import { ProtectedElement } from "../../../components/ProtectedElement/ProtectedElement.js";
import ImportModal from "../../../components/ImportModal/ImportModal.js";
import ExportBtn from "../../../components/export_btn/ExportBtn.js";

const title = "Seller Charges";
const apiUrl = recon_charges_url;
const currentRoute = "seller_charges";
const module = modules.SellerCharges;
const searchFeild = "charge_name";
const headers = [
  "Charge Name",
  "Minimum Charge",
  "Charge (%)",
  "Country",
  "Status",
  "Action",
];

const SellerCharges = () => {
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          {
            cancelToken: source.token,
            headers: {
              module: module,
            },
          }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };
  const bodyMap = (d, refetch) => {
    return [
      d.charge_name,
      d.price_value,
      d.charge_percent,
      d.country_name,

      <div className={d.is_active ? "active-green" : "active-red"}>
        {d.is_active ? "Active" : "Inactive"}
      </div>,

      <ActionDropdown
        DeleteButton={({ setOpen }) => (
          <ProtectedElement module={module} perm={perms.delete}>
            <DeleteConfirmModal
              data={d}
              dropdownCloser={() => setOpen(false)}
              route={apiUrl}
              setTableData={() => refetch()}
              module={module}
            />
          </ProtectedElement>
        )}
        EditButton={({ setOpen }) => (
          <ProtectedElement module={module} perm={perms.edit}>
            <Link to={currentRoute + "/edit/" + d.id}>
              <div
                className="option"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <div className="icon-btn green-icon">
                  <EditIcon />
                </div>
                <div className="green-title">Edit</div>
              </div>
            </Link>
          </ProtectedElement>
        )}
        ViewButton={({ setOpen }) => (
          <ProtectedElement module={module} perm={perms.view}>
            <Link to={currentRoute + "/view/" + d.id}>
              <div
                className="option"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <div className="icon-btn yellow-icon">
                  <EyeIcon />
                </div>
                <div className="yellow-title">View</div>
              </div>
            </Link>
          </ProtectedElement>
        )}
        CopyButton={({ setOpen }) => (
          <ProtectedElement module={module} perm={perms.add}>
            <Link to={currentRoute + "/copy/" + d.id}>
              <div
                className="option"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <div className="icon-btn purple-icon">
                  <CopyIcon />
                </div>
                <div className="purple-title">Copy</div>
              </div>
            </Link>
          </ProtectedElement>
        )}
      />,
    ];
  };
  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
          <ProtectedElement module={module} perm={perms.view}>
            <ExportBtn apiUrl={apiUrl} title={title} />
          </ProtectedElement>
          <ProtectedElement module={module} perm={perms.add}>
            <ImportModal file_name={currentRoute} refetch={refetch} api_url={apiUrl} />
          </ProtectedElement>
          <ProtectedElement module={module} perm={perms.add}>
            <Link to={currentRoute + "/new"}>
              <button className="btn">Add New</button>
            </Link>
          </ProtectedElement>
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            body={
              data.results
                ? data.results
                  .filter((d) =>
                    d[searchFeild]
                      .toLowerCase()
                      .includes(search.toLowerCase())
                  )
                  .map((d) => {
                    return bodyMap(d, refetch);
                  })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

export default SellerCharges;
